module.exports = __webpack_public_path__ + "static/Dance (1)-52bdd27f34b73c1b44857f0dd788806a.jpg";